import { makeRule } from '@core/utils/rule.js'
import {formRules} from '@/views/task/task.rules'

export let middleEndTaskRules = {
  ...formRules,
  taskTimeDuration: [{...makeRule('请输入做单时长', 'integer')}]
}



// WEBPACK FOOTER //
// ./src/views/middle-end-task/task.rules.js